import { render, staticRenderFns } from "./AddDevelopmentItem.vue?vue&type=template&id=36b4b68c&"
import script from "./AddDevelopmentItem.vue?vue&type=script&lang=js&"
export * from "./AddDevelopmentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/AddDevelopmentItem.vue
// module id = null
// module chunks = 